import { Component } from '@angular/core';

@Component({
    selector: 'app-objects-stat',
    templateUrl: './objects-stat.component.html',
    styleUrls: ['./objects-stat.component.css'],
    standalone: false
})
export class ObjectsStatComponent {
}
